import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form";

type TRenderFieldError<T extends FieldValues> = {
  errors: FieldErrors<T> | T | undefined;
  fieldName: keyof T;
};

const RenderFieldError = <T extends FieldValues>({
  errors,
  fieldName,
}: TRenderFieldError<T>) => {
  const fieldError = errors?.[fieldName];

  if (!fieldError) return null;

  return (
    <span className="text-red-500 text-xs">
      {fieldError.message || fieldError}
    </span>
  );
};

export default RenderFieldError;
